export const FeatureFlagsActions = {
  LOADING_IDENTITY: '[feature-flags] loading identity',
  SET_IDENTITY: '[feature-flags] set identity',
};

const initialState = {
  identity: null,
  loading: false,
};

const featureFlags = (state = initialState, action) => {
  switch (action.type) {
    case FeatureFlagsActions.LOADING_IDENTITY:
      return {
        ...state,
        loading: true,
        identity: null,
      };

    case FeatureFlagsActions.SET_IDENTITY:
      return {
        ...state,
        identity: action.payload,
        loading: false,
      };

    default:
      break;
  }

  return state;
};

export default featureFlags;
